import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ClientesService } from 'src/app/services/clientes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-viajes',
  templateUrl: './viajes.component.html',
  styleUrls: ['./viajes.component.scss']
})
export class ViajesComponent implements OnInit {
  enviroment = environment.BASE_URL;
  viajes; 
  formulario;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  respuestaViajes:any;
  respuestaDatosViaje:any;
  respuestaUpdate:any;
  respuestaAgregar:any;

  datosViaje;
  formularioEdit;
  data;
  imagenActual;
  viajeId;

  constructor(private _getViajes: ClientesService, private _getDetalleViaje:ClientesService, 
    private _updateViaje: ClientesService, private _agregarViaje: ClientesService,
    private modalService: NgbModal,
    private iziToast: Ng2IzitoastService ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 20,
      processing: true
    };

    this.formulario = {
      'nombre':'',
      'descripcion':'',
      'imagen':'',
      'precio':'',
    }

    this.formularioEdit = {
      nombre: '',
      descripcion: '',
      imagen: '',
      precio: ''
    }

    this.getViajes();
  }

  getViajes(){
    this._getViajes.getViajes().subscribe(
      data => {
        this.respuestaViajes = data;
        if(this.respuestaViajes.success){
          this.viajes = this.respuestaViajes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getDetalleViaje(viaje){
    this.data = {
      'viaje':viaje,
    }
    this._getDetalleViaje.getDetalleViaje(this.data).subscribe(
      data => {
        this.respuestaDatosViaje = data;
        if(this.respuestaDatosViaje.success){
          this.datosViaje = this.respuestaDatosViaje.content;
          console.log(this.datosViaje);
          this.formularioEdit.nombre = this.datosViaje.nombre;
          this.formularioEdit.precio = this.datosViaje.precio;
          this.formularioEdit.descripcion = this.datosViaje.descripcion;
          this.imagenActual = this.datosViaje.imagen;
          this.viajeId = this.datosViaje.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  agregarViaje(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('descripcion', this.formulario.descripcion);
    formData.append('precio', this.formulario.precio);

    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregarViaje.agregarViaje(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getViajes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateViaje(viaje){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('descripcion', this.formularioEdit.descripcion);
    formData.append('precio', this.formularioEdit.precio);
    formData.append('viaje', viaje);

    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateViaje.updateViaje(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getViajes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
